import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import Icon from '../../../../components/Section/Icon';
import svg from '../../../../static/img/external-link.svg';
import { AccountB2BContent } from './styles';
import environmentConfigs from '../../../../config/environment-configs';
import { useAuth } from '../../../../hooks/useAuth';
import { Actions, Categories, Labels } from '../../../../types/gtm';
import Action from '../../../../components/Section/Action';

const BoxAccountB2B = () => {
  const { user } = useAuth();
  const title = 'Dados profissionais';
  const describeTitle =
    'Acessar os dados da empresa e alterar preferências, área e cargo';

  const handleRedirect = environmentConfigs.GLOBO_ADS_ACCOUNT_URL;

  const sendEventGA = () => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.Home,
      event_action: Actions.ClickAccessProfessionalData,
      event_label: Labels.Home,
      bd_suser_code: user?.globoId,
    });
  };

  return (
    <Box title={title} describeTitle={describeTitle}>
      <AccountB2BContent>
        <Content>
          <Action
            onClick={sendEventGA}
            href={handleRedirect}
            theme="link"
            target="blank"
          >
            <p>Acessar dados profissionais</p>
            <Icon svg={svg} alt="icon-open-menu" />
          </Action>
        </Content>
      </AccountB2BContent>
    </Box>
  );
};

export default BoxAccountB2B;
